export const abbreviate = (
  value,
  maxPlaces,
  forcePlaces = false,
  forceLetter = false,
) => {
  const number = Number(value);
  if (forceLetter !== false) {
    return annotate(number, maxPlaces, forcePlaces, forceLetter);
  }

  const abbr = getAbbreviation(number);
  return annotate(number, maxPlaces, forcePlaces, abbr);
};

const getAbbreviation = number => {
  if (number >= 1e12) {
    return "T";
  } else if (number >= 1e9) {
    return "B";
  } else if (number >= 1e6) {
    return "M";
  } else if (number >= 1e3) {
    return "K";
  } else {
    return "";
  }
};

const doRounding = (abbr, number) => {
  switch (abbr) {
    case "T":
      return number / 1e12;
    case "B":
      return number / 1e9;
    case "M":
      return number / 1e6;
    case "K":
      return number / 1e3;
    default:
      return number;
  }
};

const annotate = (number, maxPlaces, forcePlaces, abbr) => {
  // set places to false to not round
  let rounded = doRounding(abbr, number);

  if (maxPlaces !== false) {
    const test = new RegExp("\\.\\d{" + (maxPlaces + 1) + ",}$");
    if (test.test("" + rounded)) {
      rounded = rounded.toFixed(maxPlaces);
    }
  }

  if (forcePlaces !== false) {
    rounded = Number(rounded).toFixed(forcePlaces);
  }

  return rounded + abbr;
};
